import cn from 'classnames';

export type PriceItem = {
  title: string;
  price?: number;
};

export default function PriceTable(props: {
  brand: string;
  title: string;
  priceList: Array<PriceItem>;
  priceColumn?: boolean;
}) {
  const { brand, priceList, title, priceColumn } = props;
  const commonThTdCss = 'px-[5%] py-[1.7%] pr-0 align-top';

  return (
    <>
      <h2 className="mb-3 text-xl font-bold !leading-tight text-blue-500 xs:mb-5 xs:text-2xl sm:text-3xl md:mb-8">
        {title}
      </h2>
      <div className="overflow-x-scroll">
        <table
          className={cn(
            'w-full table-auto overflow-hidden rounded-xl bg-white text-sm xs:text-sm',
            { 'xs:min-w-auto min-w-[400px]': priceColumn },
          )}
        >
          <thead className="bg-blue-600 text-left text-base text-white">
            <tr>
              <th
                className={cn(
                  commonThTdCss,
                  {
                    'w-3/12': !priceColumn,
                  },
                  {
                    'w-2/12': priceColumn,
                  },
                )}
              >
                Brand
              </th>
              <th
                className={cn(
                  commonThTdCss,
                  {
                    'w-9/12': !priceColumn,
                  },
                  {
                    'w-7/12': priceColumn,
                  },
                )}
              >
                Model
              </th>
              {priceColumn && (
                <th className={cn(commonThTdCss, 'w-3/12')}>Price (SGD)</th>
              )}
            </tr>
          </thead>
          <tbody>
            {priceList.map((priceItem, index) => (
              <tr
                className="odd:bg-blue-400/50 hover:bg-blue-400 hover:text-blue-600"
                key={`${brand}--${priceItem.title}--${index}`}
              >
                <td className={commonThTdCss}>{brand}</td>
                <td className={commonThTdCss}>{priceItem.title}</td>
                {priceColumn && (
                  <td className={commonThTdCss}>
                    {priceItem.price ? `$${priceItem.price}` : '-'}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
